import { useDropzone } from 'react-dropzone';
import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Notify from '@/components/Notification';
import { MAX_SIZE_BYTES } from '@/helpers/constants';
import { Preloader } from '@/components/Preloader';
import Icon from './assets/icon.svg';
import { FilePreview } from './file';
import s from './index.module.scss';

export const UploadField = ({ name, value, error, uploading, onChange }) => {
  const { t } = useTranslation('kit');
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: acceptedFiles => {
      onChange([...value, ...acceptedFiles]);
    },
    multiple: true,
    accept: {
      'application/pdf': ['.pdf'],
      'image/jpeg': ['.jpg', '.jpeg'],
    },
    maxSize: MAX_SIZE_BYTES,
    onDropRejected: fileRejections => {
      fileRejections.forEach(rejection => {
        rejection.errors.forEach(error => {
          if (error.code === 'file-too-large') {
            Notify.error({
              text: t('upload_file.file_too_large', { fileName: rejection.file.name }),
            });
          } else if (error.code === 'file-invalid-type') {
            Notify.error({
              text: t('upload_file.invalid_file_format', { fileName: rejection.file.name }),
            });
          }
        });
      });
    },
  });

  const onRemove = indexToRemove => {
    const updatedFiles = value.filter((_, index) => index !== indexToRemove);
    onChange(updatedFiles);
  };

  return (
    <div className={s.wrapper}>
      <div className={classnames(s.dropzone, error && s.dropzone_error)} {...getRootProps()}>
        <input name={name} {...getInputProps()} />
        <div className={s.dropzone_inner}>
          <img src={Icon} alt="icon" width={24} height={24} />
          {isDragActive ? (
            <p>{t('upload_file.drop_files_here')}</p>
          ) : (
            <p>
              <Trans
                ns="kit"
                i18nKey="upload_file.drop_jpg_pdf"
                components={{
                  Span: <span className="underline" />,
                }}
              />
            </p>
          )}
        </div>
      </div>
      {uploading ? (
        <Preloader style={{ minHeight: '150px' }} />
      ) : (
        value &&
        value.length > 0 && (
          <div className={s.files}>
            {value.map((file, index) => (
              <FilePreview
                key={index}
                name={file.name}
                size={(file.size / 1024).toFixed(1)}
                onRemove={() => onRemove(index)}
              />
            ))}
          </div>
        )
      )}
    </div>
  );
};
